import { Card, CardContent, CardHeader, CardTitle } from "@bcc/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@bcc/components/ui/chart";
import { useTranslation } from "react-i18next";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { formatRevenueYAxisTick, setRevenueChartContainerTestId, setRevenueChartTitleTestId } from "./revenue-chart.utils";

interface RevenueData {
  month: string;
  revenue: number;
}

interface RevenueChartProps {
  data: RevenueData[];
  testId?: string;
}

export function RevenueChart({ data, testId }: Readonly<RevenueChartProps>) {
  const { t } = useTranslation();
  return (
    <Card testId={testId ?? setRevenueChartContainerTestId()}>
      <CardHeader>
        <CardTitle data-testid={setRevenueChartTitleTestId()}>{t("components.revenueChart.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={{
            revenue: {
              label: t("components.revenueChart.revenueLabel"),
              color: "hsl(var(--primary))",
            },
          }}
          className="h-[300px]"
        >
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="month" className="text-xs" tickLine={false} axisLine={false} />
            <YAxis className="text-xs" tickLine={false} axisLine={false} tickFormatter={formatRevenueYAxisTick} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Area
              type="monotone"
              dataKey="revenue"
              stroke="hsl(var(--primary))"
              fill="hsl(var(--primary))"
              fillOpacity={0.2}
              strokeWidth={2}
            />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
